import React, { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useLogin } from "../../hooks/useLogin";
import { CompassParagraph } from "../../components/common/styledComponents";

export const MagicUpload: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { handleMagicLinkLogin } = useLogin();
  const hasInitiated = useRef(false);

  useEffect(() => {
    // Prevent double execution in React Strict Mode
    if (hasInitiated.current) return;
    hasInitiated.current = true;

    const token = searchParams.get("token");
    if (token) {
      handleMagicLinkLogin(token);
    } else {
      handleMagicLinkLogin("");
    }
  }, [searchParams, handleMagicLinkLogin]);

  return <CompassParagraph>Loading...</CompassParagraph>;
};
